import React from "react";
import { sortObjectsByAlphabet } from "../../utils";
import SelectV2 from "../../view/SelectV2";

function CentralCredentialsField({ centralCredentials, value, onChange, disabled }) {

    const handleChange = (value) => {
        if (String(value) === "-1" || value === "") {
            onChange(undefined);
            return;
        }

        const centralCredential = centralCredentials.find((centralCredential) => String(centralCredential.id) === String(value));
        onChange(centralCredential);
    };

    const centralCredentialsCopy = sortObjectsByAlphabet(centralCredentials, 'ccname');
    const centralCredentialOptions = [
        { value: "-1", label: "Choose" },
        ...centralCredentialsCopy.map((centralCredential) => ({
            value: String(centralCredential.id),
            label: centralCredential.ccname
        }))
    ];

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="centralCredential" className="label-central-credentials">Central Credential</label>
                <SelectV2
                    inputId="centralCredential"
                    value={String(value ?? "-1")}
                    onChange={handleChange}
                    options={centralCredentialOptions}
                    isDisabled={disabled}
                    noOptionsMessage={() => "No central credentials found"}
                />
            </div>
        </div>
    );
}

export default CentralCredentialsField;
